import React, { ReactElement } from 'react';
import './Free.scss';
import KodanshaArrow from '../../../KodanshaUIKit/KodanshaArrow/KodanshaArrow';
import { useHistory } from 'react-router-dom';

interface Props {
    title?: string;
    text?: string;
    link?: string;
    arrowText?: string;
}

const Free = ({ title, text, link, arrowText }: Props): ReactElement => {
    const history = useHistory();
    const onDetailsClicked = (): void => {
        if (link) {
            history.push('/' + link, {returnPath: history.location.pathname});
        }
    };

    return (
        <div className='series-read-free-container'>
            <div className='series-read-free-info-wrapper'>
                <span className='series-read-free-enjoy'>SERIES PREVIEW</span>
                <span className='series-read-free-title'>{title ?? 'Read for Free'}</span>
                {/* TODO: This needs to be added to the endpoint. */}
                <span
                    className='series-read-free-description'>{text ?? 'Take a peek and discover this story today.'}</span>
            </div>

            <div className='series-read-free-button-wrapper'>
                <KodanshaArrow text={arrowText ?? 'View Details'} onClick={onDetailsClicked} withArrow={true}
                               styles={'series-read-free-button'} />
            </div>
        </div>
    );
};

export default Free;
